export const YOUTUBE_THUMBNAIL_IMAGE_MAX_RES = function (key: string): string {
    return `https://img.youtube.com/vi/${key}/maxresdefault.jpg`;
};
export const YOUTUBE_THUMBNAIL_IMAGE_DEFAULT = function (key: string): string {
    return `https://img.youtube.com/vi/${key}/default.jpg`;
};

export const YOUTUBE_EMBED_VIDEO_URL = function (key: string, seekToSeconds = 0): string {
    const minutes = (seekToSeconds / 60).toFixed(0);
    const seconds = (seekToSeconds % 60).toFixed(0);
    return `https://www.youtube.com/embed/${key}?t=${minutes}m${seconds}s?vq=hd720`;
};

export const YOUTUBE_VIDEO_URL = function (key: string): string {
    return `https://www.youtube.com/watch?v=${key}`;
};

// The (?:^|[/.]) boundary keeps lookalike hosts (e.g. evilyoutube.com) from matching
const YOUTUBE_VIDEO_ID_PATTERNS: RegExp[] = [
    /(?:^|[/.])youtube\.com\/watch\?(?:[^#]*[?&])?v=([a-zA-Z0-9_-]+)/,
    /(?:^|[/.])youtube\.com\/(?:embed|shorts|v)\/([a-zA-Z0-9_-]+)/,
    /(?:^|[/.])youtu\.be\/([a-zA-Z0-9_-]+)/
];

export function getYoutubeVideoId(url?: string): string | null {
    if (!url) return null;
    for (const pattern of YOUTUBE_VIDEO_ID_PATTERNS) {
        const match = pattern.exec(url);
        if (match?.[1]) {
            return match[1];
        }
    }
    return null;
}

/**
 * True only for urls of a single playable video (a video id can be extracted) —
 * channel, playlist and other youtube.com urls are not videos.
 */
export function isYoutubeVideoUrl(url?: string): url is string {
    return getYoutubeVideoId(url) !== null;
}
